import React from "react";

const Kissimmee = () => {
  return (
    <div className="ui grid">
      <div className="two column row stackable">
        <div className="ten wide column">
          <p>
            <strong>
              <u>Kissimmee Office</u>
            </strong>
            <br />
            1132 Cypress Glen Circle
            <br />
            Kissimmee, Fl 34741
          </p>
          <p>
            Office Hours: Thursday 8-5
            <br />
            <strong>DIRECTIONS:</strong> 1/2 mile north of BJ's Wholesale Club, inside Hunter's Creek Professional Park
          </p>
        </div>
        <div className="six wide column">
          <div className="ui embed">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3511.427882693487!2d-81.41736632345545!3d28.34591067582252!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dd86dae63c280d%3A0x183c39ef30399ce!2s1132%20Cypress%20Glen%20Cir%2C%20Kissimmee%2C%20FL%2034741!5e0!3m2!1sen!2sus!4v1787244359853!5m2!1sen!2sus"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kissimmee;